export const manifest = {
  screens: {
    scr_project_list: { name: "Imperian", route: "/cases", position: {"x":2960,"y":220} },
    scr_project_detail: { name: "Case Detail", route: "/case", position: {"x":1560,"y":220} },
    scr_rv1zgs: { name: "Legal Assistant", route: "/chat", position: {"x":160,"y":220} },
    scr_files_manager: { name: "Discovery Manager", route: "/case/files", position: {"x":4360,"y":220} },
    scr_ak02ys: { name: "Ingest: Uploaded", route: "/case/ingest", state: {"phase":"idle"}, position: {"x":5760,"y":220} },
    scr_hhqca3: { name: "Ingest: Estimate", route: "/case/ingest", state: {"phase":"done"}, position: {"x":8560,"y":220} },
    scr_n8vvcc: { name: "Transcript Review", route: "/case/files/workbench", position: {"x":7160,"y":220} },
    scr_yzpwbk: { name: "Completeness", route: "/case/completeness", position: {"x":160,"y":2200} },
    scr_mfmtao: { name: "Sentencing", route: "/case/sentencing", position: {"x":1560,"y":2200} },
  },
  sections: {
    sec_o2ewuy: { name: "Main App Flow", x: 0, y: 0, width: 9920, height: 1180 },
    sec_r9xsiq: { name: "Case Analysis", x: 0, y: 1980, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_o2ewuy", children: [
      { kind: "screen", id: "scr_rv1zgs" },
      { kind: "screen", id: "scr_project_detail" },
      { kind: "screen", id: "scr_project_list" },
      { kind: "screen", id: "scr_files_manager" },
      { kind: "screen", id: "scr_ak02ys" },
      { kind: "screen", id: "scr_n8vvcc" },
      { kind: "screen", id: "scr_hhqca3" },
    ] },
    { kind: "section", id: "sec_r9xsiq", children: [
      { kind: "screen", id: "scr_yzpwbk" },
      { kind: "screen", id: "scr_mfmtao" },
    ] },
  ],
}
